(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["golden-fragrance-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('golden-fragrance-finder')) {
    class GoldenFragranceFinder extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="search"]');
        this.cards = Array.from(this.querySelectorAll('.gf__card'));
        this.cards.sort((a, b) => a.dataset.city.localeCompare(b.dataset.city, 'es'));
        this.cards.forEach(card => this.querySelector('.gf__grid').append(card));
        this.limit = 12;
        this.form.addEventListener('submit', event => {
          event.preventDefault();
          clearTimeout(this.debounce);
          this.update(true);
          this.showResults();
        });
        this.input.addEventListener('input', () => {
          clearTimeout(this.debounce);
          this.debounce = setTimeout(() => this.update(true), 180);
        });
        this.querySelectorAll('[data-note]').forEach(button => button.addEventListener('click', () => {
          this.input.value = button.dataset.note;
          this.querySelector('input[name="family"][value="all"]').checked = true;
          this.update(true);
          this.showResults();
        }));
        this.querySelectorAll('input[name="family"]').forEach(radio => radio.addEventListener('change', () => this.update(true)));
        this.querySelectorAll('.gf__reset,.gf__empty-reset').forEach(button => button.addEventListener('click', () => {
          this.input.value = '';
          this.querySelector('input[name="family"][value="all"]').checked = true;
          this.update(true);
          this.input.focus();
        }));
        this.querySelector('.gf__load').addEventListener('click', () => {
          const next = this.matches[this.limit];
          this.limit += 12;
          this.update(false);
          next?.querySelector('a').focus({ preventScroll: true });
        });
        this.update(true);
      }
      showResults() {
        this.querySelector('.gf__results').scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }
      normalize(value) {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[.!?]/g, '').replace(/\s+/g, ' ').trim();
      }
      includesNote(notes, query) {
        const groups = {
          madera: ['madera', 'amaderad', 'cedro', 'sandalo', 'oud', 'vetiver', 'pachuli', 'abedul', 'roble', 'abeto', 'cipres', 'guayaco', 'palo violeta'],
          citrico: ['citric', 'bergamota', 'limon', 'lima', 'mandarina', 'toronja', 'naranja'],
          flores: ['flor', 'rosa', 'jazmin', 'nardo', 'gardenia', 'azahar', 'neroli', 'iris', 'violeta', 'peonia', 'magnolia', 'orquidea', 'ylang', 'fresia', 'mimosa', 'loto', 'lirio', 'nenufar', 'osmanto', 'madreselva', 'tiare', 'heliotropo', 'geranio'],
          especias: ['pimienta', 'canela', 'cardamomo', 'nuez moscada', 'jengibre', 'azafran'],
          marino: ['marin', 'acuatic', 'sal marina'],
          dulce: ['vainilla', 'caramelo', 'miel', 'praline', 'azucar', 'chocolate', 'cacao', 'tonka', 'merengue', 'malvavisco', 'bizcocho', 'datiles']
        };
        const aliases = {
          maderas: 'madera', amaderado: 'madera', amaderada: 'madera', amaderados: 'madera',
          citricos: 'citrico', citrica: 'citrico', citricas: 'citrico',
          flor: 'flores', floral: 'flores', florales: 'flores',
          especia: 'especias', especiado: 'especias', especiada: 'especias',
          marinos: 'marino', acuatico: 'marino', acuatica: 'marino', acuaticos: 'marino',
          dulces: 'dulce', gourmand: 'dulce', pomelo: 'toronja', patchouli: 'pachuli', patchuli: 'pachuli', pachuli: 'pachuli',
          rosa: 'rosa', rosas: 'rosa', jazmines: 'jazmin', vainillas: 'vainilla', ambar: 'ambar',
          tonka: 'haba tonka', cacao: 'cacao', cafe: 'cafe', 'flor de naranjo': 'azahar', 'flor de naranja': 'azahar',
          'madera de agar': 'oud', agar: 'oud', musk: 'almizcle', melocoton: 'durazno',
          'fruta de la pasion': 'maracuya', 'fruto de la pasion': 'maracuya', casis: 'grosella negra',
          champan: 'champana', champagne: 'champana', cognac: 'conac', conac: 'conac',
          almizcles: 'almizcle', frambuesas: 'frambuesa', nardos: 'nardo', narcisos: 'narciso',
          almendras: 'almendra', manzanas: 'manzana', peras: 'pera', limones: 'limon', naranjas: 'naranja',
          mandarinas: 'mandarina', bergamotas: 'bergamota', gardenias: 'gardenia', violetas: 'violeta'
        };
        query = aliases[query] || query;
        if (query === 'rosa') return /\brosas?\b/.test(notes.replace(/pimienta rosa|bayas rosas|champana rosada/g, ''));
        if (query === 'coco') return /\bcoco\b/.test(notes.replace(/madera de coco/g, ''));
        if (query === 'ambar') return /\bambar\b|ambarad/.test(notes);
        if (groups[query]) return groups[query].some(term => notes.includes(term));
        const tokens = query.split(/[^a-z0-9]+/).filter(Boolean);
        const words = notes.split(/[^a-z0-9]+/).filter(Boolean).join(' ');
        return tokens.length > 0 && new RegExp('(?:^| )' + tokens.join(' ') + '(?:s|es)?(?= |$)').test(words);
      }
      inFamily(family, selected) {
        const families = { fresh: /citrica|acuatica|fresca|mineral/, floral: /floral/, fruity: /frutal/, sweet: /gourmand|dulce|mielada|avainillada/, woody: /amaderada/, spicy: /especiada/, amber: /ambarada/ };
        return selected === 'all' || (families[selected]?.test(family) ?? false);
      }
      update(reset) {
        if (reset) this.limit = 12;
        const query = this.normalize(this.input.value);
        const terms = query.split(/[,;]+|\s+y\s+|\s*\+\s*/).map(term => term.trim()).filter(Boolean);
        const selected = this.querySelector('input[name="family"]:checked').value;
        this.matches = this.cards.filter(card => terms.every(term => this.includesNote(this.normalize(card.dataset.notes), term)) && this.inFamily(this.normalize(card.dataset.family), selected));
        const shown = new Set(this.matches.slice(0, this.limit));
        this.cards.forEach(card => { card.hidden = !shown.has(card); });
        const total = this.matches.length;
        this.querySelector('.gf__status').textContent = total === 1 ? this.dataset.one : this.dataset.count.replace('__TOTAL__', String(total));
        this.querySelector('.gf__shown').textContent = total ? this.dataset.showing.replace('__SHOWN__', String(Math.min(total, this.limit))).replace('__TOTAL__', String(total)) : '';
        this.querySelector('.gf__load').hidden = total <= this.limit;
        this.querySelector('.gf__empty').hidden = total !== 0;
        this.querySelector('.gf__reset').hidden = !query && selected === 'all';
        this.querySelectorAll('[data-note]').forEach(button => button.setAttribute('aria-pressed', String(query === this.normalize(button.dataset.note))));
      }
    }
    customElements.define('golden-fragrance-finder', GoldenFragranceFinder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
